import { render, staticRenderFns } from "./ubicaciones.vue?vue&type=template&id=7b80b0e0&scoped=true"
import script from "./ubicaciones.vue?vue&type=script&lang=js"
export * from "./ubicaciones.vue?vue&type=script&lang=js"
import style0 from "./ubicaciones.vue?vue&type=style&index=0&id=7b80b0e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80b0e0",
  null
  
)

export default component.exports